import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: { customProperties: true },
        themes: {
            light: {
                primary: colors.grey.base,
                //secondary: '#424242',
                accent: colors.blue.accent4,
                error: colors.red.accent3,
                //info: '#2196F3',
                success: colors.green.accent4,
                warning: colors.yellow.darken2,
                background: colors.grey.lighten5,
                darktext: colors.blueGrey.darken4,
                greytext: '#7C8386',
                greytextlight: '#CECDCD',
                anchor: colors.blue.accent4,
                anchor20opacity: '#D1DCFB',
                bluelight: '#D3E7FE',
                bluelightBackground: '#F0F4FF',
                inputfocusblue: "#62A4FF",
                greyactivitybackground: '#F4F5F5',
                bigButtonBackground: '#f9f9f9',
                loginBackground: '#f5f4f8',
                greylightBorder: '#E0E0E0',
                pink: '#FF69AC',
                card_background_grey: '#F9F9F9',
                disabled: '#E3E3E3',
                yellowlight: '#FBEFD1',
                redlight: '#FFD1DA'

                /*primary: '#FF5252',
                anchor: '#29e3a4'
                secondary: '#BABABA',

                app_background: '#F9F9F9',
                slot_background: '#F9F9F9',
                toolbar_background: '#F9F9F9',
                list_background: '#F9F9F9',
                menu_background: '#FFFFFF',
                card_background: '#FFFFFF',
                card_background_grey: '#F9F9F9',
                activity_menu_background:'#F9F9F9',
                activity_content_background: '#FFFFFF',

                menu_header_text: '#242B31',
                dark_icon: '#242B31',
                light_icon: '#BABABA',

                tag_participant: '#0D23FB',
                tag_co_owner: '#EDBE21',
                tag_live: '#20D004',
                tag_draft: '#909090',
                tag_blocked: '#ED2150',

                grey: '#F9F9F9',


                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
            
                anchor: '#212121',
                green: '#29e3a4',
            
            
                button: '#efefef',
                link_hover_background: '#efefef',
                orange: '#F78903',
                blue: '#006CFB'*/
            },
        },
    }
});